import React from 'react';

const createValidator = (Input) => {
    return class Validator extends React.Component {

        state = {
            errors: ''
        }


        componentDidUpdate(prevProps) {
            if (prevProps.errors !== this.props.errors && !!this.props.errors) {
                window.scrollTo(0, this.input.offsetTop);
            }

        }

        validate = () => {
            const { value, validator } = this.props; 

            validator && validator.validate(value)
                .then(() =>  this.setState({ errors: '' }))
                .catch(({ errors }) => this.setState({ errors }));
        }

        render() {
            const { errors } = this.state;
            const { validator, errors: propsErrors, ...restProps } = this.props;
            return (
                <div ref={(input) => { this.input = input}}>
                    <Input validate={this.validate} {...restProps} />
                    {(errors || propsErrors) && <p style={{ color: 'rgb(255,77,0)', margin: '5px 0' }}>{propsErrors &&
                    (!!propsErrors[0].key ? propsErrors[0].key.includes('no puede ser nulo') : propsErrors[0].includes('no puede ser nulo'))
                    ? '¡Ups! Te faltó completar este dato.' : propsErrors || errors}
                    </p>}
                </div>
            );
        }
    }
}

export default createValidator;
